<template>
  <section class="slideshow-panel" :aria-labelledby="titleId">
    <!-- A card over the playing slideshow (settings, sharing on a computer): not modal, the
         film behind it stays in reach. -->
    <div class="slideshow-panel__head">
      <span aria-hidden="true" class="slideshow-panel__badge">
        <SlideshowIcon :name="icon" />
      </span>
      <div>
        <h2 class="slideshow-panel__title" :id="titleId">{{ title }}</h2>
        <p class="slideshow-panel__lead" v-if="lead">{{ lead }}</p>
      </div>
    </div>
    <div class="slideshow-panel__body">
      <slot />
    </div>
  </section>
</template>

<script lang="ts" setup>
  import { useId } from "vue";
  import type { IconName } from "./SlideshowIcon.vue";
  import SlideshowIcon from "./SlideshowIcon.vue";

  defineProps<{
    icon: IconName;
    title: string;
    lead?: string;
  }>();

  const titleId = `slideshow-panel-${useId()}`;
</script>
